import React from 'react';
import PropTypes from 'prop-types';
import { getContactLevelName } from '../../utils/contactUtils';

const ContactTableCell = ({ field, contact, handleOpenViewModal }) => {
  if (field.key === 'actions') {
    return (
      <td className="px-4 py-2">
        <button
          className="text-sss-info mr-2"
          onClick={() => {
            console.log('Contact object:', contact);
            const contactId = contact.contactId || contact.contactID || contact.buildingContactId || contact.buildingContactID;
            console.log('Extracted contactId:', contactId);
            if (!contactId || contactId === 'undefined') {
              console.error('No contact ID found in contact object:', contact);
              alert('Unable to retrieve contact details. Contact ID is missing.');
            } else {
              handleOpenViewModal(contactId);
            }
          }}
        >
          View
        </button>
      </td>
    );
  }

  if (field.key === 'contactLevel') {
    return (
      <td className="px-4 py-2">
        {getContactLevelName(contact.contactLevel)}
      </td>
    );
  }

  const value = contact[field.key];

  if (typeof value === 'boolean') {
    return <td className="px-4 py-2">{value ? '✅' : '-'}</td>;
  }

  return (
    <td className="px-4 py-2">
      {value !== null && value !== undefined ? value.toString() : 'N/A'}
    </td>
  );
};

ContactTableCell.propTypes = {
  field: PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,

  contact: PropTypes.shape({
    contactId: PropTypes.string || PropTypes.number,
    contactID: PropTypes.string || PropTypes.number,
    buildingContactId: PropTypes.string,
    buildingContactID: PropTypes.string,
    contactLevel: PropTypes.string,
  }).isRequired,
  handleOpenViewModal: PropTypes.func.isRequired,
  selectedListType: PropTypes.string.isRequired,
};

export default ContactTableCell;
